// Localized storefront display.
import { useStoreLanguage } from '@/i18n';
import { useEffect } from 'react';
import { useLocation } from '@/i18n/router';

const ScrollToTop = () => {
  useStoreLanguage();
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
